const PROTOCOL = 'mapbox://';
const ACCOUNT_NAME = 'ithacamapz';
const MAPBOX_TOKEN =
  process.env.MAPBOX_TOKEN ||
  'pk.eyJ1IjoiaXRoYWNhbWFweiIsImEiOiJja2tkOWZmNm8wbTdjMnhxc2Q0Y2c5dTllIn0.KgKcVEShHoz4r42VPMD6qQ';
const ENABLED_ROWS = false; // TODO: enable row level detail. data and design pending

const COLOR_UNAVAILABLE_SECTION = '#e4eef3';
const COLOR_AVAILABLE_SECTION = 'rgba(96, 0, 153, 1)';
const COLOR_SELECTED_SECTION = 'rgba(26, 199, 199, 1)';
const COLOR_NONGA_SECTION = '#ffffff';
const COLOR_UNAVAILABLE_SEAT = '#e4eef3';
const COLOR_SELECTED_SEAT = '#1ac7c7';
const COLOR_OUTLINE_SECTION = '#000';
const COLOR_UNAVAILABLE_ROW = '#e4eef3';
const COLOR_AVAILABLE_ROW = '#643ca2';
const COLOR_SELECTED_ROW = '#1ac7c7';
const COLOR_HOVERED_ROW = '#EE6A98';

const COLOR_OUTLINE_SELECTED = '#2f343b';

const COLOR_AVAILABLE_SEAT = 'rgba(100, 60, 162, 1)';

const COLOR_OUTLINE_ROWS = '#000';

const NAMED_TRANSFORMATIONS = {
  SHI_VENUE: 't_shi_venue',
};

const IMAGE_SOURCE_URL = `https://media.stubcloudstatic.com/stubhub-product/${NAMED_TRANSFORMATIONS.SHI_VENUE}/f_auto/Seatmaps`;

const STYLES_URL = 'styles/';
const STYLE_DEFAULT = 'cko0imr9400eo17rp1277ssgg';

const TILESET_URL = `${PROTOCOL}${ACCOUNT_NAME}`;

const TYPE_SECTION = 'section';
const TYPE_ROW = 'row';
const TYPE_SEAT = 'seat';

const LAYER_SECTIONS_ID = 'sections';
const LAYER_SECTIONS_SOURCE = `${LAYER_SECTIONS_ID}-source`;
const LAYER_SECTIONS_HIGHLIGHTED = `${LAYER_SECTIONS_ID}-highlighted`;
const LAYER_SECTIONS_OUTLINE_ID = `${LAYER_SECTIONS_ID}-outline`;
const LAYER_SECTIONS_SELECTED = `${LAYER_SECTIONS_ID}-selected`;
const LAYER_SECTIONS_HOVERED = `${LAYER_SECTIONS_ID}-hovered`;
const LAYER_SECTIONS_GA = `${LAYER_SECTIONS_ID}-GA`;
const LAYER_ROWS_OUTLINE_ID = 'rows-outline';
const LAYER_ROWS_HIGHLIGHTED = 'rows-highlighted';
const LAYER_ROWS_ID = 'rows';
const LAYER_SEATS_ID = 'seats';
const LAYER_SEATS_HIGHLIGHTED_ID = 'seats-highlighted';
const LAYER_LABELS_ID = 'labels';
const LAYER_BACKGROUND_ID = 'background';

const LAYER_SEATS_SOURCE = `${LAYER_SEATS_ID}-source`;
const LAYER_ROWS_SOURCE = `${LAYER_ROWS_ID}-source`;
const LAYER_LABELS_SOURCE = 'labels-source';
const LAYER_BACKGROUND_SOURCE = 'background-source';

const TIMING_ZOOM_DELAY = 500;

const STYLE_DEFAULT_URL = `${PROTOCOL}${STYLES_URL}${ACCOUNT_NAME}/${STYLE_DEFAULT}`;

const DEFAULT_POPUP_WIDTH = '184px';
const DEFAULT_ANCHOR_POSITION = 'bottom';
const ROW_TOOLTIP_CLASSNAME = 'mapbox_row_tooltip';
const CLICK_TOOLTIP_CLASSNAME = 'mapbox_click_tooltip';

const UNDEFINED_TYPE = 'undefined';

const RESET_CONTROL_CONTAINER_CLASSNAME = 'mapboxgl-ctrl-reset';
const RESET_CONTROL_COMPONENT_CLASSNAME = 'mapbox-reset-button';

export {
  ACCOUNT_NAME,
  STYLES_URL,
  STYLE_DEFAULT,
  STYLE_DEFAULT_URL,
  MAPBOX_TOKEN,
  TYPE_SECTION,
  TYPE_ROW,
  TYPE_SEAT,
  LAYER_SEATS_ID,
  LAYER_SECTIONS_ID,
  LAYER_SECTIONS_SELECTED,
  LAYER_SECTIONS_HOVERED,
  LAYER_SECTIONS_OUTLINE_ID,
  LAYER_SECTIONS_GA,
  LAYER_ROWS_ID,
  LAYER_ROWS_OUTLINE_ID,
  LAYER_ROWS_HIGHLIGHTED,
  LAYER_SEATS_HIGHLIGHTED_ID,
  LAYER_SECTIONS_HIGHLIGHTED,
  LAYER_LABELS_ID,
  LAYER_BACKGROUND_ID,
  LAYER_SEATS_SOURCE,
  LAYER_ROWS_SOURCE,
  LAYER_LABELS_SOURCE,
  LAYER_BACKGROUND_SOURCE,
  LAYER_SECTIONS_SOURCE,
  COLOR_UNAVAILABLE_SECTION,
  COLOR_AVAILABLE_SECTION,
  COLOR_SELECTED_SECTION,
  COLOR_OUTLINE_SECTION,
  COLOR_NONGA_SECTION,
  COLOR_OUTLINE_ROWS,
  COLOR_AVAILABLE_SEAT,
  COLOR_UNAVAILABLE_SEAT,
  COLOR_SELECTED_SEAT,
  COLOR_UNAVAILABLE_ROW,
  COLOR_AVAILABLE_ROW,
  COLOR_SELECTED_ROW,
  COLOR_HOVERED_ROW,
  COLOR_OUTLINE_SELECTED,
  ENABLED_ROWS,
  DEFAULT_POPUP_WIDTH,
  DEFAULT_ANCHOR_POSITION,
  ROW_TOOLTIP_CLASSNAME,
  CLICK_TOOLTIP_CLASSNAME,
  IMAGE_SOURCE_URL,
  TIMING_ZOOM_DELAY,
  TILESET_URL,
  UNDEFINED_TYPE,
  RESET_CONTROL_CONTAINER_CLASSNAME,
  RESET_CONTROL_COMPONENT_CLASSNAME,
};
